import { TRegionAggregatedState } from './types';

export function setRegionAggregated(state: TRegionAggregatedState, data: TRegionAggregatedState['regionAggregated']) {
  state.regionAggregated = data;
}
